/*
 * @Description: Jerry Create File
 * @Version: 1.0
 * @Author: Jerry
 * @Date: 2024-07-29 11:27:00
 * @LastEditors: zhanglin
 * @LastEditTime: 2024-09-02 14:50:48
 */
module.exports = {
  apiUrl: {
    //  本地环境接口请求地址
    dev: 'https://t-app.yaoyueyue.com:4477',
    dev_downlodUrl: 'https://t-app.yaoyueyue.com:4479',
    // dev_downlodUrl: 'http://192.168.199.201:9095',
    //  生产环境接口请求地址
    pro: 'https://apisyzl.yaoyueyue.com',
    pro_downloadUrl: 'https://downsyzl.yaoyueyue.com'
  },
  PublicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAq98h403Yx9c45EDR3DBrefexh8sXeNGVF+WG1O4QuIDZRcUel917RAzMUUDZexgRNQdYQzN8JYL60xM4GUsEWLO4/5N/HqLDNXXRA6UgLRavFtWS5JtUODQhuKTKQcQQx/XKwT19MIJgX5cNDQh4GWdPpyl98nxLKym+1xXT1wiRPKWD53mwQGwq2cdBe9sRxhK3m/rGS7GqYwj6doFOpH3y8KxF92hACdP+380zusE2eKh3/XLf3ZaCgWcSEO1DKTM36YB6c5T9wWXXk7nT/GwKkIUYx1pjr5Didmc8t/BO2+ctdPuq8hA7p86hCErW5Kvp9pxQ0SRRfGRz01vXPwIDAQAB'
}



// WEBPACK FOOTER //
// ./src/config/index.js